<template>
  <twemoji-picker
    :emojiData="emojiData"
    :emojiGroups="emojiGroups"
    :skinsSelection="skinsSelection"
    :searchEmojisFeat="searchEmojisFeat"
    :searchEmojiPlaceholder="searchEmojiPlaceholder"
    :searchEmojiNotFound="searchEmojiNotFound"
    :isLoadingLabel="isLoadingLabel"
    :options="options"
    ref="picker"
    @emojiUnicodeAdded="onEmojiUnicodeAdded"
    @emojiImgAdded="onEmojiImgAdded"
  >
    <template v-slot:twemoji-picker-button>
      <slot name="twemoji-picker-button"></slot>
    </template>
  </twemoji-picker>
</template>

<script>
  import {
    TwemojiPicker
  } from '@kevinfaguiar/vue-twemoji-picker';
  // import EmojiAllData from '@/assets/emoji-data/ja/emoji-all-groups.json';
  import EmojiDataSmileysEmotion from '@/assets/emoji-data/ja/emoji-group-smileys-emotion.json';
  import EmojiDataSmileysEmotionSmall from '@/assets/emoji-data/ja/emoji-group-smileys-emotion-small.json';
  import EmojiDataAnimalsNature from '@/assets/emoji-data/ja/emoji-group-animals-nature.json';
  import EmojiDataComponent from '@/assets/emoji-data/ja/emoji-group-component.json';
  import EmojiDataFlags from '@/assets/emoji-data/ja/emoji-group-flags.json';
  import EmojiDataFoodDrink from '@/assets/emoji-data/ja/emoji-group-food-drink.json';
  import EmojiDataObjects from '@/assets/emoji-data/ja/emoji-group-objects.json';
  import EmojiDataPeopleBody from '@/assets/emoji-data/ja/emoji-group-people-body.json';
  import EmojiDataSymbols from '@/assets/emoji-data/ja/emoji-group-symbols.json';
  import EmojiDataTravelPlaces from '@/assets/emoji-data/ja/emoji-group-travel-places.json';
  import EmojiGroups from '@/assets/emoji-data/emoji-groups.json';

  export default {
    name: 'TwemojiPicker',
    components: {
        'twemoji-picker': TwemojiPicker
    },
    props: {
      skinsSelection: {
        type: Boolean,
        default: false,
      },
      searchEmojisFeat: {
        type: Boolean,
        default: false,
      },
      searchEmojiPlaceholder: {
        type: String,
        default: "Search here.",
      },
      searchEmojiNotFound: {
        type: String,
        default: "Emojis not found.",
      },
      isLoadingLabel: {
        type: String,
        default: "Loading...",
      },
      emojiUnicodeAddedHandlerName: {
        type: String,
        default: "emoji-unicode-added",
      },
      emojiImgAddedHandlerName: {
        type: String,
        default: "emoji-img-added",
      },
      options: {
        type: Object,
        default: null,
      },
    },
    computed: {
      emojiData() {
        // return EmojiAllData;
        return [
          EmojiDataSmileysEmotion,
          //EmojiDataPeopleBody,
          //EmojiDataAnimalsNature,
          //EmojiDataFoodDrink,
          //EmojiDataComponent,
          //EmojiDataFlags,
          //EmojiDataObjects,
          //EmojiDataSymbols,
          //EmojiDataTravelPlaces,
          // EmojiDataSmileysEmotionSmall,
        ];
      },
      emojiGroups() {
        return EmojiGroups;
      },
    },
    methods: {
      onEmojiUnicodeAdded: function(emojiUnicode) {
        // this.$utils.log('onEmojiUnicodeAdded: ' + emojiUnicode);
        this.$emit(this.emojiUnicodeAddedHandlerName, emojiUnicode, this.options);
        this.$refs.picker.isPickerOpen = false;
      },
      onEmojiImgAdded: function(emojiImgTag) {
        // this.$utils.log('onEmojiImgAdded: ' + emojiImgTag);
        this.$emit(this.emojiImgAddedHandlerName, emojiImgTag, this.options);
      },
    }
  }
</script>
